"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationLogDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class NotificationLogDto {}
exports.NotificationLogDto = NotificationLogDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationLogDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationLogStatus
}), __metadata("design:type", String)], NotificationLogDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationLogChannel
}), __metadata("design:type", String)], NotificationLogDto.prototype, "channel", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationType,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "notificationType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "recipientUserPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "recipientFullName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationLogDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "presetPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "presetName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "failureReason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.ModelName,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "referenceModel", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationLogDto.prototype, "referenceId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationLogDto.prototype, "createdAt", void 0);
//# sourceMappingURL=NotificationLog.dto.js.map